export default __webpack_public_path__ + "static/media/threejs.c43313a4.png";